export const path = "/validaciones-cierre-aluna";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "VALIDACIONES / CIERRE ALUNA",
  section: "ALUNA",
  group: "CSM",
  order: 1,
  roles: [
    "Authenticated",
    "aluna",
    "aluna-management",
  ],
};
